// AnotherKind — mobile product gallery tap-on-sides + zoom disable
(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 749;
  const isMobile = () => window.innerWidth <= MOBILE_BREAKPOINT;

  function setupGallery(gallery) {
    if (gallery.dataset.akTapInit === 'true') return;
    gallery.dataset.akTapInit = 'true';

    const mediaList = gallery.querySelector('[data-product-media-list]');
    if (!mediaList) return;

    let touchStartX = 0;
    let touchStartY = 0;
    let touchMoved = false;

    mediaList.addEventListener('touchstart', (e) => {
      if (e.touches && e.touches[0]) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchMoved = false;
      }
    }, { passive: true });

    mediaList.addEventListener('touchmove', (e) => {
      if (e.touches && e.touches[0]) {
        const dx = Math.abs(e.touches[0].clientX - touchStartX);
        const dy = Math.abs(e.touches[0].clientY - touchStartY);
        if (dx > 10 || dy > 10) touchMoved = true;
      }
    }, { passive: true });

    // CAPTURE PHASE listener on the gallery element itself
    // This runs BEFORE any child element's listeners (including zoom.js)
    gallery.addEventListener('click', (e) => {
      if (!isMobile()) return;

      // Allow genuine interactive elements through
      if (e.target.closest('button, a, .deferred-media, video, model-viewer, [data-thumb-link], [data-button-arrow]')) {
        return;
      }

      // Check if click is inside the slides area (main product image)
      const isInsideSlides = e.target.closest('[data-product-media-list], [data-zoom-image], .product__photo, .product__slide');
      if (!isInsideSlides) return;

      // If user was swiping, don't trigger side-tap
      if (touchMoved) {
        // Still block zoom
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      if (gallery.classList.contains('is-dragging')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      // Block the default zoom behavior
      e.preventDefault();
      e.stopImmediatePropagation();

      // Determine side-tap zone
      const rect = mediaList.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const width = rect.width;

      if (clickX < width * 0.3) {
        if (typeof gallery.showPreviousImage === 'function') gallery.showPreviousImage();
      } else if (clickX > width * 0.7) {
        if (typeof gallery.showNextImage === 'function') gallery.showNextImage();
      }
      // Middle 40% — do nothing (zoom was blocked above, no side-tap action)
    }, true); // CAPTURE PHASE — runs before child listeners
  }

  function init() {
    document.querySelectorAll('product-images').forEach(setupGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run with delays to catch any late-loaded content (zoom.js loads with defer)
  setTimeout(init, 200);
  setTimeout(init, 800);
  setTimeout(init, 2000);

  // Re-run on variant changes
  document.addEventListener('theme:media:select', init);

  // Debug
  window.akGalleryDebug = function() {
    const galleries = document.querySelectorAll('product-images');
    console.log('[AK] Found', galleries.length, 'galleries');
    galleries.forEach((g, i) => {
      console.log(`[AK] Gallery ${i}:`, {
        initialized: g.dataset.akTapInit,
        hasShowNext: typeof g.showNextImage === 'function',
        hasShowPrev: typeof g.showPreviousImage === 'function',
        isMobile: isMobile(),
        windowWidth: window.innerWidth,
        zoomImagesCount: g.querySelectorAll('[data-zoom-image]').length
      });
    });
  };
})();